import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TextInput } from './Form'
import { SEARCH_BY_KEY, GET_BY_ID } from '../../../requests'
import { Result } from '../../ResultsDrawer/ResultsDrawer'
import Portal from 'components/Portal/Portal'
import { Modal } from '../../Modal/Modal'
import { noop } from 'utilities'
import SearchIcon from '@tecuity/sos-icons/react/search-heavy'
import RevertIcon from '@tecuity/sos-icons/react/revert'
import { Spinner } from 'components/Loaders/Loaders'
import * as WizardClasses from '../WizardClasses'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'

class SearchControl extends Component {
  static defaultProps = { metadata: {} }
  constructor(props) {
    super()
    this.state = {
      search: '',
      modalOpen: false,
      results: [],
      filter: '',
      loading: props.value !== null,
      loadingMultiResults: false,
      searching: false
    }
  }
  componentDidMount = () => {
    if (this.props.value) {
      if (Array.isArray(this.props.value)) {
        this.getMultiById(this.props.value)
      } else {
        this.getById(this.props.value.SOURCE_ID)
      }
    }
  }
  getById = (sourceId, callback) =>
    new Promise((resolve, reject) => {
      if (sourceId) {
        const SEARCH_TYPE = this.props.searchType || 'ACTIVE_FILINGS'
        const query = `?${this.getSearchQuery()}`
        GET_BY_ID(SEARCH_TYPE, sourceId + query, result => {
          this.setState({ loading: false })
          this.props.onChange(result, { target: { name: this.props.name } })
          resolve(result)
        })
      } else {
        resolve()
      }
    })
  getMultiById = results => {
    this.setState({ loadingMultiResults: true })
    const promises = results.map(
      result =>
        new Promise((resolve, reject) => {
          if (result.SOURCE_ID) {
            const SEARCH_TYPE = this.props.searchType || 'ACTIVE_FILINGS'
            GET_BY_ID(SEARCH_TYPE, result.SOURCE_ID, resolve)
          } else {
            reject()
          }
        })
    )
    Promise.all(promises).then(values => {
      this.setState({ loadingMultiResults: false })
      this.props.onChange(values, {})
    })
  }
  onSearchChange = value => {
    this.setState({ search: value })
  }
  getSearchQuery = () => {
    const parameterFields = this.getFieldParameters();
    const params = (this.props.additionalParameters || Object.keys(parameterFields).length
          ? { ...parameterFields, ...this.props.additionalParameters }
          : {})
    const paramsString = Object.entries(params).reduce((str, [key, value], index) => {
      if(index !== 0){
        str += "&"
      }
      str += `${key}=${encodeURIComponent(typeof value === "object" ? JSON.stringify(value) : value)}`
      return str;
    }, "")
    return paramsString
  }
  getFieldParameters = () =>
    (this.props.parameterFields || [])
      .map(fieldId => this.props.fields[fieldId])
      .filter(x => x)
      .filter(field =>
        resolveFieldConditions(field.conditions, this.props.fields, field.conditionsOperator)
      )
      .map(
        field =>
          new WizardClasses[field.fieldClass](field).getKeyValuePairs(field, this.props.fields)[0]
      )
      .reduce(
        (obj, kv) => ({
          ...obj,
          [kv.name]: kv.value
        }),
        {}
      )
  search = () => {
    this.setState({ searching: true })
    const SEARCH_TYPE = this.props.searchType || 'ACTIVE_FILINGS'
    const parameterFields = this.getFieldParameters()
    SEARCH_BY_KEY(
      SEARCH_TYPE,
      {
        SEARCH_VALUE: this.state.search,
        ...(this.props.additionalParameters || Object.keys(parameterFields).length
          ? { ADDITIONAL_PARAMS: { ...parameterFields, ...this.props.additionalParameters } }
          : {})
      },
      results => {
        this.setState({ results: ((SEARCH_TYPE === 'ACTIVE_FILINGS|CRA' && process.env.DISALLOW_ASSIGN_SELF_AS_RA && this.props.parentId) || (process.env.DISALLOW_ASSIGN_SELF_AS_PRINCIPAL && this.props.parentId)) 
              ? results.filter(result => result.SOURCE_ID.toString() !== this.props.parentId.toString()) 
              : results, modalOpen: true, searching: false })
        if (this.filterInput) {
          this.filterInput.focus()
        }
      },
      err => {
        this.setState({ searching: false })
        console.error(err)
      }
    )
  }
  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }
  checkForSubmit = e => {
    if (e.charCode === 13) {
      e.stopPropagation()
      this.search()
    }
  }
  filter = e => {
    this.setState({ filter: e.target.value })
  }
  onFilterKeyUp = ({ keyCode }) => {
    if (keyCode === 27) {
      this.setState({ modalOpen: false })
      this.searchInput.focus()
    }
  }
  selectResult = result => {
    this.getById(result.SOURCE_ID).then(result => {
      this.toggleModal()
    })
  }
  selectMultiResults = () => {
    const results = this.selectableResults.getSelected()
    this.getMultiById(results)
  }
  deSelect = () => {
    this.props.onChange(null, { target: { name: this.props.name, value: null } })
  }
  deSelectAll = () => {
    this.props.onChange([], {})
  }
  deSelectRow = index => {
    const newRows = [...this.props.value.slice(0, index), ...this.props.value.slice(index + 1)]

    this.props.onChange(newRows, { target: { name: this.props.name, value: newRows } })
  }
  onBlur = (value, e) => {
    this.props.onBlur(this.props.value, e)
  }
  setNameValue = (value, e) => {
    this.props.onChange({ ...this.props.value, ...value }, e)
  }
  getFilteredOptions = labels => {
    return labels.reduce((options, label, index) => {
      if (label !== '') {
        return [...options, { value: index.toString(), label }]
      } else {
        return options
      }
    }, [])
  }
  getDefaultOrgType = (currentValue, filteredOptions) => {
    if (filteredOptions.length) {
      filteredOptions.forEach(option => {
        if (option.value === currentValue) {
          return option.value
        }
      })
      return filteredOptions[0].value
    }
  }
  selectAll = () => {
    this.selectableResults.setGlobalSelect(true)
  }
  selectNone = () => {
    this.selectableResults.setGlobalSelect(false)
  }
  render() {
    const {
      value,
      disabled,
      modalTitle,
      width,
      fullWidthResult = true,
      placeholder,
      fieldId,
      multiSelect
    } = this.props
    const hasNotSelectedResult = multiSelect ? !value.length : !value

    return (
      <div className="organization-search" style={{ width }}>
        {hasNotSelectedResult ? (
          <div className="row">
            <div className="col-12 search-input-wrapper">
              <TextInput
                {...this.props}
                value={this.state.search}
                fieldId={fieldId}
                ref={r => {
                  this.searchInput = r
                }}
                name="SEARCH_VALUE"
                className="text-input"
                onBlur={() => {}}
                width={width}
                onKeyPress={this.checkForSubmit}
                onChange={this.onSearchChange}
                placeholder={placeholder}
                aria-label="Search"
              />
              <button
                type="button"
                className="btn btn-primary btn-raised search-button live"
                onClick={this.search}
                disabled={disabled || this.state.searching}
              >
                {this.state.searching ? (
                  <div className="button-loading-wrapper">
                    <Spinner size="small" themeColor="inherit" /> Searching
                  </div>
                ) : (
                  <React.Fragment>
                    <SearchIcon /> Search
                  </React.Fragment>
                )}
              </button>
            </div>
          </div>
        ) : multiSelect ? (
          this.state.loadingMultiResults ? (
            value.map((row, i) => (
              <div
                className={`shimmer-result-placeholder ${
                  fullWidthResult ? 'col' : 'col-md-8 col-lg-7'
                }`}
                style={{ animationDelay: `${-i * 120}ms` }}
                key={i}
              ></div>
            ))
          ) : (
            <React.Fragment>
              {!disabled && (
                <div className="flex-row button-row" style={{ marginBottom: 15, marginLeft: -10 }}>
                  <button
                    disabled={disabled}
                    type="button"
                    className="btn btn-raised btn-primary search-button"
                    onClick={this.deSelectAll}
                  >
                    <RevertIcon /> &nbsp; Clear Results & Re-Search
                  </button>
                </div>
              )}
              {value.map((row, i) => (
                <div style={{ marginBottom: 10 }} key={row.SOURCE_ID + row.SOURCE_TYPE_ID}>
                  <SelectedResultDisplay
                    value={row}
                    disabled={disabled}
                    fullWidthResult={fullWidthResult}
                    onRequestDeselect={() => this.deSelectRow(i)}
                  />
                </div>
              ))}
            </React.Fragment>
          )
        ) : (
          <SelectedResultDisplay
            value={value}
            disabled={disabled}
            fullWidthResult={fullWidthResult}
            onRequestDeselect={this.deSelect}
          />
        )}
        <Portal isOpened={this.state.modalOpen}>
          <Modal
            title={modalTitle !== '' ? modalTitle : 'Search'}
            closeModal={this.toggleModal}
            modalSize="medium"
            saveAndCloseButton={multiSelect}
            cancelButton={multiSelect}
            closeButton={!multiSelect}
            save={multiSelect ? this.selectMultiResults : undefined}
            cancel={noop}
          >
            <div className="results-wrapper">
              <div className="filter-wrapper">
                <input
                  type="text"
                  className="filter"
                  // placeholder="Filter Results..."
                  ref={r => (this.filterInput = r)}
                  onChange={e => {
                    this.onSearchChange(e.target.value)
                  }}
                  onKeyPress={this.checkForSubmit}
                  value={this.state.search}
                />
                <button
                  type="button"
                  className="btn btn-primary search-button live"
                  onClick={this.search}
                  disabled={disabled || this.state.searching}
                >
                  {this.state.searching ? (
                    <div className="button-loading-wrapper">
                      <Spinner size="small" themeColor="inherit" /> Searching
                    </div>
                  ) : (
                    <React.Fragment>
                      <SearchIcon /> Search
                    </React.Fragment>
                  )}
                </button>
                {multiSelect && (
                  <button
                    className="btn btn-default search-button select-button"
                    type="button"
                    onClick={this.selectAll}
                  >
                    Select All
                  </button>
                )}
                {multiSelect && (
                  <button
                    className="btn btn-default search-button select-button"
                    type="button"
                    onClick={this.selectNone}
                  >
                    Select None
                  </button>
                )}
                {!multiSelect && (
                  <div className="align-right">
                    <span className="info">{`Showing ${this.state.results.length} result(s)`}</span>
                  </div>
                )}
              </div>
              <Results
                ref={ref => (this.selectableResults = ref)}
                data={this.state.results}
                selectResult={this.selectResult}
                multiSelect={multiSelect}
                toolbarChildren={
                  <div className="align-right">
                    <span className="info">{`Showing ${this.state.results.length} result(s)`}</span>
                  </div>
                }
              />
            </div>
          </Modal>
        </Portal>
      </div>
    )
  }
}
export default connect(state => ({
  fields: state.wizard.wizard.fields,  
  parentId: state.wizard.wizard.meta.FILING_ID,
}))(SearchControl)

class Results extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: this.calculateInitialSelection(props.data)
    }
  }
  componentDidUpdate = prevProps => {
    if (prevProps.data !== this.props.data) {
      this.setState({
        selected: this.calculateInitialSelection(this.props.data)
      })
    }
  }
  calculateInitialSelection = data =>
    data.reduce((obj, result, i) => {
      obj[i] = false
      return obj
    }, {})
  getSelected = () => this.props.data.filter((result, i) => this.state.selected[i])
  select = (index, isSelected) => {
    this.setState(state => ({
      selected: {
        ...state.selected,
        [index]: isSelected
      }
    }))
  }
  setGlobalSelect = isSelected => {
    this.setState({
      selected: this.props.data.reduce((obj, result, i) => {
        obj[i] = result.DISABLED ? false : isSelected
        return obj
      }, {})
    })
  }
  render() {
    const { selectResult, data, multiSelect, toolbarChildren } = this.props
    return (
      <div className="results-modal-body-wrapper" style={{paddingTop: multiSelect ? 26 : 0}}>
        {multiSelect && <div className="results-toolbar">{toolbarChildren}</div>}
        <div className="flex-column-wrapper scroll-wrapper results-list-wrapper">
          {data.map((result, i) => (
            <Result
              element="button"
              data={result}
              onClick={selectResult}
              selectable={multiSelect}
              isSelected={this.state.selected[i]}
              onSelectToggled={isSelected => this.select(i, isSelected)}
              key={i}
            />
          ))}
        </div>
      </div>
    )
  }
}

const SelectedResultDisplay = ({ fullWidthResult, value, disabled, onRequestDeselect }) => (
  <div className="row">
    <div className={fullWidthResult ? 'col' : 'col-md-8 col-lg-7'}>
      <Result
        className="static static-selected-result animated fadeInUp fast-animation"
        data={value}
      >
        {!disabled ? (
          <button
            type="button"
            className="close"
            aria-label="Clear selection"
            onClick={onRequestDeselect}
          >
            <span className="icon icon-close"></span>
          </button>
        ) : null}
      </Result>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/SearchControl.js